import React from 'react';
import { useAppContext } from '../../context/AppContext';
import { useLanguage } from '../../context/LanguageContext';
import { i18n } from '../../i18n/i18n';
import { KidButton } from '../kid/KidUI';
import AntMascot from '../AntMascot';

/**
 * What a family member without admin access sees when the family's access has ended
 * (payments groundwork). Grown-ups with admin access get the Subscription page instead (App.tsx).
 */
const Paywall: React.FC = () => {
  const { switchUser, logout } = useAppContext() as any;
  const { current_language } = useLanguage();
  return (
    <main className="min-h-screen w-full flex items-center justify-center px-4 py-8 bg-kid-page dark:bg-kid-bg-dark text-kid-text dark:text-kid-text-dark" lang={current_language}>
      <div className="w-full max-w-md rounded-kid-card border-2 border-kid-border dark:border-kid-border-dark bg-kid-card dark:bg-kid-card-dark p-6 space-y-4 text-center">
        <AntMascot className="w-24 h-24 mx-auto" />
        <h1 className="font-kid-heading font-extrabold text-2xl">{i18n.t('billing.paywall_title')}</h1>
        <p className="text-lg">{i18n.t('billing.paywall_text')}</p>
        <div className="flex flex-col gap-3 pt-2">
          <KidButton size="md" onClick={() => switchUser?.()}>{i18n.t('settings.switch_person')}</KidButton>
          <KidButton size="md" variant="secondary" onClick={() => logout()}>{i18n.t('deletion.log_out')}</KidButton>
        </div>
      </div>
    </main>
  );
};

export default Paywall;
